import { LitElement, css, html } from '@lit'
import styles from '@nova/styles'
import { formatPrice, t } from '@nova/utils'

class NovaFreeShippingThreshold extends LitElement {
  static properties = {
    threshold: {
      type: Number,
    },
    cartSubtotal: {
      type: Number,
      attribute: 'cart-subtotal'
    },
    percentageValue: {
      type: Number,
      state: true,
    },
  }

  get percentageValue() {
    return (this.cartSubtotal / this.threshold) * 100
  }

  constructor() {
    super()

    this.threshold = Number(__NOVA_GLOBAL__.freeShippingThreshold) * 100
  }

  _calculateRemaining() {
    return formatPrice(this.threshold - this.cartSubtotal)
  }

  _displayMessage() {
    let message
    if (this.cartSubtotal >= this.threshold) {
      message = t('sections.cart.free_shipping.done')
    } else {
      message = `${this._calculateRemaining()}${t('sections.cart.free_shipping.more')}`
    }

    return message
  }

  render() {
    return html`
      <div class="wrapper">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M3.22656 6.21484V7.30575H13.5902V15.4876H10.2324C9.98911 14.55 9.14584 13.8512 8.13566 13.8512C7.12547 13.8512 6.2822 14.55 6.03893 15.4876H5.40838V12.7603H4.31747V16.5785H6.03893C6.2822 17.5161 7.12547 18.2148 8.13566 18.2148C9.14584 18.2148 9.98911 17.5161 10.2324 16.5785H14.7662C15.0095 17.5161 15.8528 18.2148 16.8629 18.2148C17.8731 18.2148 18.7164 17.5161 18.9597 16.5785H20.6811V12.1297L20.6467 12.0441L19.5558 8.77142L19.4375 8.39665H14.6811V6.21484H3.22656ZM3.77202 8.39665V9.48756H8.68112V8.39665H3.77202ZM14.6811 9.48756H18.6525L19.5902 12.2831V15.4876H18.9597C18.7164 14.55 17.8731 13.8512 16.8629 13.8512C15.8528 13.8512 15.0095 14.55 14.7662 15.4876H14.6811V9.48756ZM4.31747 10.5785V11.6694H7.59021V10.5785H4.31747ZM8.13566 14.9421C8.7449 14.9421 9.22657 15.4238 9.22657 16.033C9.22657 16.6423 8.7449 17.1239 8.13566 17.1239C7.52635 17.1239 7.04474 16.6423 7.04474 16.033C7.04474 15.4238 7.52635 14.9421 8.13566 14.9421ZM16.8629 14.9421C17.4722 14.9421 17.9538 15.4238 17.9538 16.033C17.9538 16.6423 17.4722 17.1239 16.8629 17.1239C16.2536 17.1239 15.772 16.6423 15.772 16.033C15.772 15.4238 16.2536 14.9421 16.8629 14.9421Z" fill="#332E2C"/>
        </svg>
        <p>${this._displayMessage()}</p>
      </div>
      <sl-progress-bar value=${this.percentageValue}></sl-progress-bar>
    `
  }

  static styles = [
    styles.flex,
    css`
      :host {
        display: flex;
        flex-direction: column;
        gap: var(--nova-space-2xs);
        padding: var(--nova-space-xs) 0;
      }

      .wrapper {
        display: flex;
        align-items: center;
        gap: 3.5px;
      }

      p {
        font: var(--nova-body-small);
        letter-spacing: var(--nova-body-small-letter-spacing);
        text-transform: var(--nova-body-small-text-transform);
        -webkit-font-smoothing: antialiased;
        color: var(--nova-color-moink-dark-grey);
        margin: 0;
      }

      sl-progress-bar {
        --height: 3px;
        --track-color: var(--free-shipping-bar-track-color);
        --indicator-color: var(--free-shipping-bar-indicator-color);
      }
    `,
  ]
}

customElements.define('nova-free-shipping-threshold', NovaFreeShippingThreshold)
